namespace $ {

	export class $shm_hitalama_map_widget_entity_custom_owner extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map ) {}
	export class $shm_hitalama_map_widget_entity_custom_source extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ) {}
	export type $shm_hitalama_map_widget_entity_custom_source_kind = 'tree' | 'logic' | 'style' | 'demo' | 'default' | 'readme'

	export class $shm_hitalama_map_widget_entity_custom extends $giper_baza_entity.with({

		Class_name: $giper_baza_atom_text,
		Description: $giper_baza_atom_text,
		Github_repository: $giper_baza_atom_text,
		Versions_store: $giper_baza_atom_link.to( ()=> $shm_hitalama_components_versions_store ),
		Drafts_store: $giper_baza_atom_link.to( ()=> $shm_hitalama_components_drafts_store ),
		// Class_base: $giper_baza_atom_text,
		Code_view_tree: $giper_baza_text,
		Code_css: $giper_baza_text,
		Code_js: $giper_baza_text,
		Source_format: $giper_baza_atom_text,
		Owner_map: $shm_hitalama_map_widget_entity_custom_owner,
		Owner_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_components_catalog ),
		Tree_source: $shm_hitalama_map_widget_entity_custom_source,
		Logic_source: $shm_hitalama_map_widget_entity_custom_source,
		Style_source: $shm_hitalama_map_widget_entity_custom_source,
		Demo_source: $shm_hitalama_map_widget_entity_custom_source,
		Default_source: $shm_hitalama_map_widget_entity_custom_source,
		Readme_source: $shm_hitalama_map_widget_entity_custom_source,
		Dependencies: $giper_baza_atom_text,
		Test_scenarios: $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $shm_hitalama_components_scenario ) ),

		Visible_in_contextmenu: $giper_baza_atom_bool,

	}) {
		widget_type( next?: boolean ) {
			if( next !== undefined && !this.can_change() ) throw new Error( 'Нет прав на изменение типа виджета.' )
			return this.Visible_in_contextmenu( next === undefined ? undefined : null )?.val( next ) ?? false
		}

		display_name() {
			const title = this.title().trim()
			if( title && title !== this.class_name() ) return title
			return this.class_name().replace( /^\$[^_]+_/, '' ).split( '_' ).map( word =>
				[ 'crm', 'api', 'ui', 'html' ].includes( word ) ? word.toUpperCase() : word.charAt( 0 ).toUpperCase() + word.slice( 1 ),
			).join( ' ' )
		}

		@ $mol_mem
		class_name() {
			return this.Class_name()?.val() || this.Code_view_tree()?.value().split(' ', 1)[0] || ''
		}

		source_format(): 'ts' | 'js' { return this.Source_format()?.val() === 'ts' ? 'ts' : 'js' }

		@ $mol_action
		rename( name: string ) {
			const previous = this.class_name()
			if( previous === name ) return name
			const owner = this.Owner_map()?.remote()
			const prefix = '$' + owner?.link().str + '_'
			if( this.source_format() !== 'ts' || !name.startsWith( prefix ) || !/^\$[A-Za-z0-9_]+$/.test( name ) ) {
				throw new Error( `FQN должен начинаться с ${ prefix } и содержать только буквы, цифры и _` )
			}
			if( owner?.Customs()?.remote_list().some( item => item.link().str !== this.link().str && item.class_name() === name ) ) {
				throw new Error( `Компонент ${ name } уже существует на карте.` )
			}
			const sources = ( [ 'tree', 'logic', 'style' ] as const ).map( kind => [ kind, this.source_text( kind ) ] as const )
			const identifier = new RegExp( `(^|[^$A-Za-z0-9_])${ previous.replaceAll( '$', '\\$' ) }(?![$A-Za-z0-9_])`, 'g' )
			for( const [ kind, text ] of sources ) this.source_text( kind, text.replace( identifier, ( _, prefix )=> prefix + name ) )
			this.Class_name( null )!.val( name )
			return name
		}

		source_link( kind: $shm_hitalama_map_widget_entity_custom_source_kind, next?: $shm_hitalama_map_widget ): $shm_hitalama_map_widget | null {
			const atom = kind === 'tree' ? this.Tree_source( next === undefined ? undefined : null )
				: kind === 'logic' ? this.Logic_source( next === undefined ? undefined : null )
				: kind === 'style' ? this.Style_source( next === undefined ? undefined : null )
				: kind === 'default' ? this.Default_source( next === undefined ? undefined : null )
				: kind === 'readme' ? this.Readme_source( next === undefined ? undefined : null )
				: this.Demo_source( next === undefined ? undefined : null )
			if( next !== undefined ) atom!.remote( next )
			return atom?.remote() ?? null
		}

		@ $mol_mem_key
		source_text( kind: $shm_hitalama_map_widget_entity_custom_source_kind, next?: string ): string {
			if( next !== undefined ) return this.source_write( kind, next )
			const source = this.source_link( kind )
			if( source ) return source.text()
			if( kind === 'demo' || kind === 'default' ) return 'const obj = new $' + `component(${ JSON.stringify( this.class_name() ) })\nreturn obj`
			if( kind === 'readme' ) return ''
			return ( kind === 'tree' ? this.Code_view_tree() : kind === 'logic' ? this.Code_js() : this.Code_css() )?.value() ?? ''
		}

		@ $mol_action
		source_write( kind: $shm_hitalama_map_widget_entity_custom_source_kind, text: string ) {
			const source = this.source_link( kind ) ?? $mol_wire_sync( this ).source_create( kind )
			this.source_link( kind, source )
			source.text( text )
			return text
		}

		source_create( kind: string ): $shm_hitalama_map_widget {
			const source = this.land().area_make().Data( $shm_hitalama_map_widget )
			source.Map( null )!.remote( this.Owner_map()?.remote() ?? null )
			source.title( this.class_name() + '.' + kind )
			return source
		}

		dependencies(): { fqn: string, link: string }[] {
			return ( this.Dependencies()?.val() ?? '' ).split( '\n' ).map( line => line.trim() ).filter( Boolean ).map( line => {
				const parts = line.split( /\s+/ )
				if( parts.length !== 2 || !/^\$[A-Za-z0-9_]+$/.test( parts[0] ) ) {
					throw new Error( 'Зависимости: укажите «FQN ссылка-на-определение», по одной на строку.' )
				}
				return { fqn: parts[0], link: parts[1] }
			})
		}

	}

}
